import {
  Box,
  Collapse,
  Divider,
  EllipsisText,
  ExpandMoreRoundedIcon,
  Flex,
  Rotate,
  Text,
} from '@shared/components';
import { useState } from 'react';

interface TopicCollapsibleProps {
  topicName: string;
  subTopicNames: string[];
}
export default function TopicCollapsible(props: Readonly<TopicCollapsibleProps>) {
  const { topicName, subTopicNames } = props;
  const [isExpand, setIsExpand] = useState(false);

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[200]}`,
        backgroundColor: theme.palette.common.white,
      })}
      onClick={() => setIsExpand((prev) => !prev)}
    >
      <Flex
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          p: (theme) => theme.spacing(3, 4),
        }}
      >
        <Text variant='body2Semibold'>{topicName}</Text>

        <Rotate in={isExpand}>
          <ExpandMoreRoundedIcon />
        </Rotate>
      </Flex>
      <Collapse in={isExpand}>
        <Divider />
        <Flex sx={(theme) => ({ p: theme.spacing(3, 4), gap: theme.spacing(2) })}>
          <Text
            variant='caption'
            sx={{ flexShrink: 0, color: (theme) => theme.palette.text.secondary }}
          >
            Sub-Topic:
          </Text>
          <Box>
            {subTopicNames.map((subTopicsName) => {
              return (
                <EllipsisText
                  key={subTopicsName}
                  variant='caption'
                  sx={{ color: (theme) => theme.palette.text.secondary }}
                >
                  {subTopicsName}
                </EllipsisText>
              );
            })}
          </Box>
        </Flex>
      </Collapse>
    </Flex>
  );
}
